import { render, staticRenderFns } from "./ShipmentsTable.vue?vue&type=template&id=62164ccd&scoped=true"
import script from "./ShipmentsTable.vue?vue&type=script&lang=js"
export * from "./ShipmentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62164ccd",
  null
  
)

export default component.exports